import ProfileIcon from "./ProfileIcon";

const AthletesIcon = ProfileIcon;
export default AthletesIcon;
